import { MouseEvent, useState } from 'react';

import { Specialty } from '@/lib/types';

import Link, { LinkVariant } from '@/components/link';
import Select from '@/components/select';
import Typography from '@/components/typography';

import { Region } from '@/services/regions.service';
import { routes } from '@/utils/route-utils';

type SearchAdventureProps = {
  specialty: Specialty;
  specialties: Specialty[];
  regions: Region[];
};

export default function SearchAdventure({
  specialty,
  specialties,
  regions,
}: SearchAdventureProps) {
  const [selectedSpecialty, setSelectedSpecialty] = useState<
    Specialty | undefined
  >(specialty);
  const [selectedLocations, setSelectedLocations] = useState<Region[]>();

  const onSearch = (e: MouseEvent) => {
    e.preventDefault();

    window.location.href = routes.jobSearch({
      discipline: specialty?.discipline?.apiId || undefined,
      ordering: 'highest_pay',
      specialty: selectedSpecialty?.title,
      locations: selectedLocations?.map((location) => location.name),
    });
  };

  return (
    <div className='mx-auto flex max-w-[240px] flex-col gap-4 rounded-lg bg-primary-light p-4 sm:p-6 lg:max-w-full'>
      <Typography.Heading5 className='text-center'>
        Start your Nomad adventure!
      </Typography.Heading5>

      <Select
        placeholder='Specialty'
        labelKey='title'
        valueKey='slug'
        uniqueKey='id'
        options={specialties}
        selectedOptions={selectedSpecialty}
        onSelect={(option) => setSelectedSpecialty(option as Specialty)}
        rounded
        className='border-0 shadow-sm'
      />

      <Select
        placeholder='Location'
        labelKey='name'
        valueKey='name'
        uniqueKey='id'
        options={regions}
        selectedOptions={selectedLocations}
        onSelect={(option) => setSelectedLocations(option as Region[])}
        multiple
        rounded
        className='border-0 shadow-sm'
      />

      <Link
        variant={LinkVariant.PRIMARY_BUTTON}
        href='#'
        className='flex-1'
        onClick={onSearch}
      >
        Search Jobs
      </Link>
    </div>
  );
}
